import { Component, OnInit } from '@angular/core';
import {IPermission} from '../../../model/interfaces/permissions.interface';
import {PermissionsService} from './permissions.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';


@Component({
  selector: 'app-rights-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss']
})
export class PermissionsComponent implements OnInit {

    public loading = false;
    rows = new Array<IPermission>();

    constructor(
        private permissionsService: PermissionsService,
        private toastr: ToastrService,
        private router: Router ) {
    }

    ngOnInit() {
        this.loading = true;
        this.permissionsService.getAll().subscribe(result => {
            this.rows = result.data;

            window.dispatchEvent(new Event('resize'));
            this.loading = false;
        },
        error => {
            console.log(error);
            this.loading = false;
            window.dispatchEvent(new Event('resize'));
            this.toastr.error('TimeOut occured', 'Service Error', {
                timeOut: 3000,
            });
        })
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/rights/permissions/permissions.component.ts